<template>
    <div>
        <b-modal v-model="mostrarModal" @show="iniciarForm()">
            <div slot="modal-title">Relatório de Faturamento de Etapas</div>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Inicial</label>
                        <date-picker v-model="dataInicial" :config="$datePickerOptions2"
                            v-mask="'##/##/####'"></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Data Final</label>
                        <date-picker v-model="dataFinal" :config="$datePickerOptions2"
                            v-mask="'##/##/####'"></date-picker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Fornecedor</label>
                        <b-form-select :plain="true" :options="fornecedores" text-field="razaoSocial"
                            value-field="cpfCnpj" v-model="fornecedor"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Gestor</label>
                        <b-form-select :plain="true" :options="gestores" text-field="gestor" value-field="codGestor"
                            v-model="gestor"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade</label>
                        <b-form-select :plain="true" :options="unidades" text-field="unidade" value-field="unidade"
                            v-model="unidade"></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fechar()" class="mr-2">Cancelar</b-button>
                <b-button variant="primary" @click.stop="filtrar()">Emitir Relatório</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import FornecedoresServicos from '../../../fornecedores/FornecedoresServicos'

export default {
    props: {
        servicos: {
            type: Object
        }
    },

    data() {
        return {
            mostrarModal: false,
            dataInicial: null,
            dataFinal: null,
            fornecedores: [],
            fornecedor: -1,
            gestores: [],
            gestor: -1,
            unidades: [],
            unidade: 'TODAS'
        }
    },

    methods: {
        iniciarForm() {
            this.$store.dispatch('addRequest')

            // Carregar opções de filtro (gestores e unidades)
            this.servicos.obterOpcoesFiltro().then((response) => {
                if (response && response.success) {
                    this.unidades = response.data.unidades
                    this.unidades.unshift({ unidade: 'TODAS' })

                    this.gestores = response.data.gestores
                    this.gestores.unshift({
                        codGestor: -1,
                        gestor: 'TODOS'
                    })
                }
            })

            // Carregar fornecedores
            FornecedoresServicos.obterTodos().then((response) => {
                if (response && response.success) {
                    this.fornecedores = response.data
                    this.fornecedores.unshift({
                        fornecedorId: -1,
                        razaoSocial: 'TODOS'
                    })
                } else {
                    this.$toast.error(
                        'Erro ao obter lista de fornecedores',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
                this.$store.dispatch('removeRequest')
            }).catch(() => {
                this.$toast.error(
                    'Erro ao obter opções dos filtros',
                    'ERROR',
                    this.$toastConfig.error
                )
                this.$store.dispatch('removeRequest')
            })
        },

        abrir() {
            this.dataFinal = null;
            this.dataInicial = null;
            this.fornecedor = null;
            this.gestor = null;
            this.unidade = null;

            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
        },

        filtrar() {
            // Validação de datas
            if (this.dataInicial && this.dataFinal) {
                const dataInicialMoment = this.$moment(this.dataInicial, 'DD/MM/YYYY')
                const dataFinalMoment = this.$moment(this.dataFinal, 'DD/MM/YYYY')

                if (dataFinalMoment.isBefore(dataInicialMoment)) {
                    this.$toast.error(
                        'A data final não pode ser menor que a data inicial',
                        'ERROR',
                        this.$toastConfig.error
                    )
                    return
                }
            }

            let filtroDto = {}

            if (this.dataInicial) {
                filtroDto.dataInicial = this.$moment(
                    this.dataInicial,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.dataFinal) {
                filtroDto.dataFinal = this.$moment(
                    this.dataFinal,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.fornecedor != -1) {
                filtroDto.fornecedor = this.fornecedor
            }

            if (this.gestor != -1) {
                filtroDto.gestor = this.gestor
            }

            if (this.unidade != 'TODAS') {
                filtroDto.unidade = this.unidade
            }

            this.$emit('filtrar', filtroDto)
            this.fechar()
        }
    }
}
</script>